module.exports = (__webpack_require__(4))(1717);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/react-router/es/Redirect.js from dll-reference vendorProd_library
// module id = 643
// module chunks = 42